// Notice(消息)插件服务

import { CORE_PLUGIN } from "@/core";
import type { ConsolePageOption, ConsolePageService, Plugin } from "@/plugins";
import { injectOptional } from "@/tsyringe-extend";
import { defineStore } from "pinia";
import {
  container,
  instanceCachingFactory,
  registry,
  singleton
} from "tsyringe";
import type { RouteRecordRaw } from "vue-router";
import {
  PLUGIN_CONSOLE_PAGE,
  PLUGIN_NOTICE
} from "../../builtin/BuiltinPluginSymbol";
import type { NoticePageOption, NoticeService } from "./DeclareType";
import NoticeAll from "./view/NoticeAll.vue";
import NoticeSeed from "./view/NoticeSeed.vue";
import NoticeSetting from "./view/NoticeSetting.vue";
import NoticeUnread from "./view/NoticeUnread.vue";

export const NoticePageOptionsInjectKey = "NoticePageOptionsInjectKey";

const createState = (): NoticePageOption => {
  return {
    disabledNotice: false,
    modules: {
      noticeAll: true,
      noticeUnread: true,
      noticeSeed: true,
      noticeSetting: true
    }
  };
};

export const useNoticeStore = defineStore("noticeStore", {
  state: createState,
  actions: {}
});

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<NoticePageOption, NoticeService>>(
      (c) => c.resolve(DefaultNoticePlugin)
    )
  }
])
export class DefaultNoticePlugin
  implements Plugin<NoticePageOption, NoticeService>
{
  id: string | symbol = PLUGIN_NOTICE;
  options: NoticePageOption;
  service: NoticeService;
  constructor(
    @injectOptional(NoticePageOptionsInjectKey)
    options: NoticePageOption
  ) {
    const instantiationStore = useNoticeStore();
    this.service = instantiationStore;
    this.options = instantiationStore.$state;
    if (options) {
      instantiationStore.$patch(options);
    }
  }

  init(): void {
    container.register<NoticeService>(PLUGIN_NOTICE, {
      useValue: this.service
    });
    const { disabledNotice } = this.options;
    if (disabledNotice) {
      const plugin =
        container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
          PLUGIN_CONSOLE_PAGE
        );
      const noticeRoutes = [
        {
          name: "notice-all",
          path: "messages/message_all",
          component: NoticeAll
        },
        {
          name: "notice-seed",
          path: "messages/message_read",
          component: NoticeSeed
        },
        {
          name: "notice-unread",
          path: "messages/message_unread",
          component: NoticeUnread
        },
        {
          name: "notice-setting",
          path: "messages/settings",
          component: NoticeSetting
        }
      ] as RouteRecordRaw[];
      noticeRoutes.forEach((r) => {
        plugin.service.addChildRoute(r);
      });
    }
  }

  initialized(): void {
    //
  }
}
